import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IonRow } from '@ionic/react';
import { BarChart, Title } from '@tremor/react';
import PropTypes from 'prop-types';

function FinancialsBarGraph({ graphData, xLabel }) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const handleScreenSize = useCallback(() => {
    setIsSmallScreen(window.innerWidth < 768);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleScreenSize);
    return () => {
      window.removeEventListener('resize', handleScreenSize);
    };
  }, [handleScreenSize]);

  return (
    <>
      <Title>Financials</Title>
      <BarChart
        className="mt-6"
        data={graphData}
        index="month"
        categories={["payments", "invoices", "expenses"]}
        colors={["green", "blue", "indigo"]}
        layout={isSmallScreen ? "vertical" : "horizontal"}
      />
      <IonRow className="ion-justify-content-center ion-align-items-center">
        {xLabel}
      </IonRow>
    </>
  );
}

FinancialsBarGraph.propTypes = {
  graphData: PropTypes.array.isRequired,
  xLabel: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({});
const mapDispatchToProps = {};

export default withRouter(connect(
  mapStateToProps, mapDispatchToProps
)(FinancialsBarGraph));
